import { MARQUEE_ITEMS } from "@/lib/site-data";

export default function Marquee() {
  const doubled = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="marquee" className="overflow-hidden border-y border-white/5 bg-[#0A0C0F] py-6">
      <div className="flex w-max animate-marquee items-center gap-12">
        {doubled.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-12">
            <span className="whitespace-nowrap font-serif text-2xl italic text-slate-500">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-terra/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
